export default "__VITE_ASSET__DBiEJ0kH__"